import axios from 'axios'

const { REACT_APP_API_BASE_URL } = process.env

export const renewAuth = (transactionId: string) => {
    const url = `${REACT_APP_API_BASE_URL}/auth/${transactionId}/renew`
    return axios.post(url, {})
}